// react
import React from 'react';

// third-party
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

// application
import { ArrowRoundedRight6x9Svg } from '../../svg';

function PageHeader(props) {
    let { breadcrumb } = props;

    if (!breadcrumb || breadcrumb.length === 0) {
        return null;
    }

    const lastIndex = breadcrumb.length - 1;

    const breadcrumbItems = breadcrumb.map((item, index) => {
        if (lastIndex === index) {
            return (
                <li key={index} className="breadcrumb-item active" aria-current="page" title={item.title}>
                    <span className="breadcrumb-item__title">{item.title}</span>
                </li>
            );
        }
        return (
            <li key={index} className="breadcrumb-item" title={item.title}>
                <Link to={item.url} className="breadcrumb-item__link">{item.title}</Link>
                <ArrowRoundedRight6x9Svg className="breadcrumb-arrow" />
            </li>
        );
    });

    return (
        <div className="page-header d-none d-md-block">
            <div className="page-header__container container">
                <div className="page-header__breadcrumb">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            {breadcrumbItems}
                        </ol>
                    </nav>
                </div>
            </div>
        </div>
    );
}

PageHeader.propTypes = {
    /** page header */
    header: PropTypes.node,
    /** array of breadcrumb links */
    breadcrumb: PropTypes.array,
};

PageHeader.defaultProps = {
    breadcrumb: [],
};

export default PageHeader;
